import * as lib from '~/dependencies';

export const Message = lib.styled.span`
  font-size: 13px;
  line-height: 1.35;
`;

/**
 * A button, not an anchor: it runs a handler rather than navigating, and inside a toast an `href`
 * would be a real navigation waiting to happen. Styled to read as the link the copy promises.
 */
export const SettingsLink = lib.styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-weight: bold;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;
